export function SolidButton({ children, onClick ,className="",type="",disabled=false}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type={type}
      className= {`flex items-center justify-center space-x-1 
        text-sm font-medium-200 
        text-slate-100 bg-blue-600
        hover:bg-blue-700 px-3 py-2 rounded-lg 
        cursor-pointer
        disabled:bg-gray-400 disabled:cursor-not-allowed disabled:hover:bg-gray-400

        hover:shadow-xl hover:shadow-blue-500/20 transition-all duration-300 group ${className}`}
    >
      {children}
    </button>
  );
}